(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('InvoiceController', InvoiceController);

    InvoiceController.$inject = ['$scope', 'InvoiceMinDTO', 'InvoiceGridDTO', 'AlertService', 'SingleDblClickService', 'category', 'InvoiceCustomService','$uibModal','ToastrService'];

    function InvoiceController ($scope, InvoiceMinDTO, InvoiceGridDTO, AlertService, SingleDblClickService, category, InvoiceCustomService, $uibModal, ToastrService) {
        var vm = this;

        vm.invoices = [];
        vm.category = category;
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.loadAll = loadAll;
        vm.initFilterData = initFilterData;
        vm.updateInvoiceStatus = updateInvoiceStatus;

        vm.filterModel = {};
        $scope.dateOptions = {
            formatYear: 'yy',
            startingDay: 1
        };
        $scope.invoiceDateFrom = {
            opened: false
        };
        $scope.invoiceDateTo = {
            opened: false
        };
        $scope.openInvoiceDateFrom = function () {
            $scope.invoiceDateFrom.opened = true;
        };
        $scope.openInvoiceDateTo = function () {
            $scope.invoiceDateTo.opened = true;
        };
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.invoiceDateFrom = false;
        vm.datePickerOpenStatus.invoiceDateTo = false;

        vm.shipments = [];
        vm.shipmentStatuses = [];
        vm.shipmentBLs = [];
        vm.shipmentLCs = [];
        vm.contracts = [];
        vm.contractStatuses = [];
        vm.contractTypes = [];

        vm.fieldsMapping = {
            "invoiceNum": "invoiceNum",
            "invoiceDate": "invoiceDate",
            "status": "status",
            "qtyBales": "qtyBales",
            "value": "value",
            "shipmentNum": "shipmentNum",
            "shipmentStatus": "shipmentStatus",
            "shipmentQty": "shipmentQtyDisplay",
            "shipmentLcNumber": "shipmentLcNumber",
            "shipmentBlNumber": "shipmentBlNumber",
            "contractNum": "contractNum",
            "contractType": "contractType",
            "contractStatus": "contractStatus"
        };

        vm.getInvoiceFieldName = function(dtoName) {
            return vm.fieldsMapping[dtoName] || dtoName;
        };

        vm.gridOptions = {
            paginationPageSizes: [10, 25, 50, 75, 100],
            paginationPageSize: 100,
            enableFiltering: false,
            enableGridMenu: true,
            enableRowSelection: true,
            enableSelectAll: true,
            showGridFooter: true,
            useExternalPagination: true,
            rowTemplate: SingleDblClickService.rowTemplate(),
            onRegisterApi: function( gridApi ) {
                gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
                    vm.page = newPage - 1;
                    loadAll();
                });
                gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
                    if (sortColumns && sortColumns.length > 0 && sortColumns[0]) {
                        vm.predicate = vm.getInvoiceFieldName(sortColumns[0].field);
                        vm.reverse = sortColumns[0].sort.direction === 'asc';
                    } else {
                        vm.predicate = 'id';
                        vm.reverse = true;
                    }
                    loadAll();
                });
                $scope.gridApi = gridApi;
            },
            enableColumnResizing: true,
            columnDefs: [
                { name: 'Invoice #', field: 'invoiceNum', width: 150, visible: true },
                { name: 'Date', field: 'invoiceDate', width: 150, visible: true },
                { name: 'Status', field: 'status', width: 150, visible: true },
                { name: 'Qty', field: 'qtyBales', width: 150, visible: true },
                { name: 'Value', field: 'value', width: 250, visible: true },
                { name: 'Shipment #', field: 'shipmentNum', width: 150, visible: true },
                { name: 'S. Status', field: 'shipmentStatus', width: 150, visible: true },
                { name: 'S. Qty', field: 'shipmentQtyDisplay', width: 150, visible: true },
                { name: 'S. Lc #', field: 'shipmentLcNumber', width: 150, visible: true },
                { name: 'S. Bl #', field: 'shipmentBlNumber', width: 150, visible: true },
                { name: 'Contract #', field: 'contractNum', width: 150, visible: true },
                { name: 'C. Type', field: 'contractType', width: 150, visible: true },
                { name: 'C. Status', field: 'contractStatus', width: 150, visible: true }
            ]
        };

        initFilter();
        loadAll();
        initFilterData();

        function initFilterData() {
            InvoiceCustomService.returnUsedShipmentStatuses(vm.category.type).then(function (data) {
                vm.shipmentStatuses = data.data;
            }, function (error) {
                vm.shipmentStatuses = [];
            });
            InvoiceCustomService.returnUsedContractStatuses(vm.category.type).then(function (data) {
                vm.contractStatuses = data.data;
            }, function (error) {
                vm.contractStatuses = [];
            });
            InvoiceCustomService.returnUsedContractTypes(vm.category.type).then(function (data) {
                vm.contractTypes = data.data;
            }, function (error) {
                vm.contractTypes = [];
            });
        }

        function initFilter() {
            vm.filterModel = {
                invoiceNum: '',
                invDateFrom: '',
                invDateTo: '',
                status: '',
                type: vm.category.type,
                qtyBalesFrom: '',
                qtyBalesTo: '',
                valueFrom: '',
                valueTo: '',
                shipmentNum: '',
                shipmentStatus: '',
                shipmentBL: '',
                shipmentLC: '',
                contractNum: '',
                contractStatus: '',
                contractType: ''
            };
        }

        function loadAll () {
            if (vm.gridOptions) {
                vm.gridOptions.data = [];
            }
            vm.invoices = [];
            var queryParams = {
                type: vm.category.type,
                page: vm.page,
                size: vm.gridOptions.paginationPageSize,
                sort: sort()
            };
            if (vm.category.status && vm.category.status.length > 0) {
                queryParams.status = vm.category.status
            }
            queryParams = Object.assign({}, queryParams, vm.filterModel);
            // InvoiceMinDTO.query(queryParams, onSuccess, onError);
            InvoiceGridDTO.query(queryParams, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.invoices = angular.copy(data);
                vm.gridOptions.data = vm.invoices;
                vm.gridOptions.totalItems = headers('X-Total-Count');
                $scope.gridApi.selection.clearSelectedRows();
                ToastrService.success("Successfully fetched " + vm.category.type + " Invoices","Success!");
            }

            function onError(error) {
                ToastrService.error(error.data.message, "Error");
            }
        }

        function reset () {
            vm.page = 0;
            vm.invoices = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        $scope.rowSingleClick = function(row) {
            switch (vm.category.type) {
                case 'PURCHASE':
                    SingleDblClickService.singleClick( row, 'invoice-purchase.invoice-purchase-detail', 'invoice' );
                    break;
                case 'SALE':
                    SingleDblClickService.singleClick( row, 'invoice-sale.invoice-sale-detail', 'invoice' );
                    break;
                case 'JAPAN':
                    SingleDblClickService.singleClick( row, 'japan.japan-detail', 'invoice' );
                    break;
                default:
                    break;
            }
        };

        $scope.rowDblClick = function(row) {
            switch (vm.category.type) {
                case 'PURCHASE':
                    SingleDblClickService.dblClick( row, 'invoice-purchase.edit', 'invoice' );
                    break;
                case 'SALE':
                    SingleDblClickService.dblClick( row, 'invoice-sale.edit', 'invoice' );
                    break;
                case 'JAPAN':
                    SingleDblClickService.dblClick( row, 'japan.edit', 'invoice' );
                    break;
                default:
                    break;
            }


        };

        vm.createTab = function(data) {
            $scope.$emit('handleEmit', data);
        };

        vm.cleanFilter = function() {
            initFilter();
            vm.reset();
        };

        function updateInvoiceStatus() {
            var modalInstance = $uibModal.open({
                templateUrl: 'app/entities/invoice/dialogs/invoice-update-status.html',
                controller: 'InvoiceUpdateStatusController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: function() {
                        return $scope.gridApi.selection.getSelectedRows();
                    }
                }
            });
            modalInstance.result.then(function() {
                reset();
            });
        }
    }
})();
